// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumbs":"style_Breadcrumbs__29PZG","Arrow":"style_Arrow__1aNT2","Link":"style_Link__OjYmB"};